export const getLotStageLabel = stage => {
  switch (stage) {
    case 'PreProcess':
      return 'Pre Processing';
    case 'Process':
      return 'Processing';
    case 'Drying':
      return 'Drying';
    default:
      return stage;
  }
};
